import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import LoginCleverTap, { ILoginCleverTapProps } from "../generic/loginCleverTap";
import logo from "../../../assets/images/logo_white.jpg";

export interface ILoginClevertapScreenProps extends ILoginCleverTapProps {
	onClose?: () => void;
}

const LoginClevertapScreen: React.FC<ILoginClevertapScreenProps> = (props) => {
	return (
		<LoginPopup
			leftHeaderContent={!DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			onClose={props.onClose}
			className="change_pw_scrn"
		>
			<LoginCleverTap {...props} />
		</LoginPopup>
	);
};

export default LoginClevertapScreen;
